<div class="custom-multiselect-empresa-dropdown">
    <!-- Container -->
    <div class="tag-container" (click)="toggleDropdown()">
        <span class="fake-placeholder" *ngIf="!selectedItem">{{'LABELS.ALL_COMPANIES' | translate}}</span>

        <!-- Valor selecionado -->
        <span class="tag" *ngIf="selectedItem" (click)="$event.stopPropagation()">
            {{ selectedItem.nomeFantasia }} <span class="remove" (click)="removeSelected(); $event.stopPropagation()">
                <span style="font-size: 10px;" class="material-symbols-outlined">close</span>
            </span>
        </span>
        

        <!-- Ícone seta -->
        <span [ngClass]="{'active': showDropdown}" class="arrow_keyboard_down material-symbols-outlined">
            keyboard_arrow_down
        </span>

        <!-- Caixa de pesquisa -->

    </div>

    <!-- Dropdown -->
    <ul class="dropdown-empresa-select open-settings-trig" *ngIf="showDropdown">

        <div style="border-bottom: 1px solid var(--color-gray-old);" class="h-40 u-gap-5 flex u-p-10 w-full">
            <span class="material-symbols-outlined u-text-primary-dark u-fs-18">
                search
            </span>
            <input placeholder="EX: Ondetah" class="h-full w-75-percent" type="text" [(ngModel)]="inputValue"
                (click)="$event.stopPropagation()" (input)="onSearchChange(inputValue)" *ngIf="showDropdown" />
        </div>
        <li *ngFor="let empresa of filteredOptions" (click)="selectItem(empresa)">
            {{ empresa.nomeFantasia }}
        </li>

        <span *ngIf="showDropdown && filteredOptions.length === 0"
            class="u-fs-11 h-40 flex u-p-10  u-text-primary-dark u-text-center w-full">
            {{'LABELS.NOT_FOUND' | translate}}
        </span>
    </ul>


</div>